/**
 * @fileoverview Field-name helpers and contact object factories for ContactsData.
 */

/** Translation key for "show in profile" toggle label */
export const SHOW_IN_PROFILE_KEY = "components.contactInformation.showInProfile";

/** Stable fallback so useMemo does not see a new [] each run when contactos is missing */
export const EMPTY_CONTACTOS_DEFAULT = [];

/** Keys on additional contact objects synced to flat `contactoN*` fields (excludes `id`) */
export const ADDITIONAL_CONTACT_PARENT_KEYS = [
  "titulo",
  "nombre",
  "segundoNombre",
  "apellidoPaterno",
  "apellidoMaterno",
  "telefono",
  "telefonoCodigoPais",
  "mostrarTelefono",
  "celular",
  "celularCodigoPais",
  "mostrarCelular",
  "extension",
  "mostrarExtension",
  "correoElectronico",
  "mostrarCorreoElectronico",
  "fechaNacimiento",
  "mostrarFechaNacimiento",
  "genero",
  "mostrarGenero",
  "area",
  "mostrarArea",
];

export const parentFieldNameForContactKey = (contactNumber, key) =>
  `contacto${contactNumber}${key.charAt(0).toUpperCase() + key.slice(1)}`;

export const createEmptyAdditionalContact = (id) => ({
  id,
  titulo: null,
  nombre: "",
  segundoNombre: "",
  apellidoPaterno: "",
  apellidoMaterno: "",
  telefono: "",
  telefonoCodigoPais: null,
  celular: "",
  celularCodigoPais: null,
  extension: "",
  correoElectronico: "",
  fechaNacimiento: "",
  genero: 0,
  area: "",
  mostrarTelefono: false,
  mostrarCelular: false,
  mostrarExtension: false,
  mostrarCorreoElectronico: false,
  mostrarFechaNacimiento: false,
  mostrarGenero: false,
  mostrarArea: false,
});

export const mapAdditionalContactFromApi = (contact, index) => ({
  id: contact?.id || `contact-${index}-${Date.now()}`,
  titulo: contact?.titulo || null,
  nombre: contact?.nombre || "",
  segundoNombre: contact?.segundoNombre || "",
  apellidoPaterno: contact?.apellidoPaterno || "",
  apellidoMaterno: contact?.apellidoMaterno || "",
  telefono: contact?.telefono || "",
  telefonoCodigoPais: contact?.telefonoCodigoPais || null,
  celular: contact?.celular || "",
  celularCodigoPais: contact?.celularCodigoPais || null,
  extension: contact?.extension || "",
  correoElectronico: contact?.correoElectronico || "",
  fechaNacimiento: contact?.fechaNacimiento || "",
  genero: contact?.genero || 0,
  area: contact?.area || "",
  mostrarTelefono: contact?.mostrarTelefono ?? false,
  mostrarCelular: contact?.mostrarCelular ?? false,
  mostrarExtension: contact?.mostrarExtension ?? false,
  mostrarCorreoElectronico: contact?.mostrarCorreoElectronico ?? false,
  mostrarFechaNacimiento: contact?.mostrarFechaNacimiento ?? false,
  mostrarGenero: contact?.mostrarGenero ?? false,
  mostrarArea: contact?.mostrarArea ?? false,
});
